module.exports = __webpack_public_path__ + "img/logement-maison.bbc9b4bf.png";